import React from 'react';

import {
  faArrowUpFromBracket,
  faCalendar,
  faCalendarCheck,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircleDollarToSlot,
  faClock,
  faExclamationTriangle,
  faEye,
  faInfoCircle,
  faListCheck,
  faLocationCrosshairs,
  faSearch,
} from '@medely/pro-regular-svg-icons';
import { faCaretDown } from '@medely/pro-solid-svg-icons';
import { BaseIcon, type IconDefinition } from './BaseIcon';
import type { IconName, IconProps } from './interface';

const ICON_MAP: Record<IconName, IconDefinition> = {
  'arrow-up-from-bracket': faArrowUpFromBracket,
  calendar: faCalendar,
  'calendar-check': faCalendarCheck,
  'caret-down-solid': faCaretDown,
  check: faCheck,
  'chevron-down': faChevronDown,
  'chevron-left': faChevronLeft,
  'chevron-right': faChevronRight,
  'chevron-up': faChevronUp,
  'circle-dollar-to-slot': faCircleDollarToSlot,
  clock: faClock,
  'exclamation-triangle': faExclamationTriangle,
  'eye-regular': faEye,
  'info-circle': faInfoCircle,
  'list-check': faListCheck,
  'location-crosshairs': faLocationCrosshairs,
  search: faSearch,
};

export const Icon = (props: IconProps) => {
  const { name, ...iconProps } = props;
  return <BaseIcon {...iconProps} icon={ICON_MAP[name]} />;
};
